import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import * as S from './styles';
//components
import LayoutModal from '../../../LayoutModal';
import ProgressBar from "../../../ProgressBar";
import FormsAddress from '../FormsAddress';
import FormsCustomer from '../FormsCustomer';
//hooks
import { Inputs } from 'Interfaces/ICustomerAddress';
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from '../../../../hooks/useLoading';
//interfaces
import { IAgreement } from 'Interfaces/IAgreement';
import { ICustomer } from 'Interfaces/ICustomerAddress';
interface IProps {
    isOpenModal: boolean,
    setIsOpenModal: () => void,
    setToastOpen: (value: boolean) => void;
    setToastData: (data: { status: number; message: string }) => void;
    refreshData: () => void;
}

export default function LayoutCustomer({
    isOpenModal,
    setIsOpenModal,
    setToastOpen,
    setToastData,
    refreshData
}: IProps) {
    const {
        register,
        control,
        reset,
        setValue,
        handleSubmit: handleFormSubmit,
        formState: { errors },
    } = useForm<Inputs>();

    const [customerID, setCustomerID] = useState<number | null>();
    const [isOpensCustomer, setIsOpensCustomer] = useState(true);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const textInformation = isOpensCustomer ? {
        title: 'Registrar Cliente',
        subTitle: 'Cadastre um novo cliente em sua base de dados.'
    } : {
        title: 'Registrar Endereço',
        subTitle: 'Cadastre um novo endereço em sua base de dados.'
    }

    const [agreements, setAgreements] = useState<IAgreement[]>([]);

    const fetchData = async () => {
        try {
            const response = await apiRequest<IAgreement[]>('agreement');
            const dataResponse = response.data;
            if (dataResponse.length > 0) {
                setAgreements(dataResponse);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        if (isOpenModal) {
            fetchData();
        }
    }, [isOpenModal]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        startLoading();
        try {
            // Etapa 1: Avançar para o formulário de endereço
            if (isOpensCustomer) {
                setIsOpensCustomer(false);
                stopLoading();
                return;
            }

            // Etapa 2: Salva os dados
            let customer_id = customerID || null;
            console.log('debugar id: ', customer_id);
            if (!customer_id) {
                // 1. Montar os dados do cliente
                const customerPayload = {
                    full_name: data.full_name.toUpperCase(),
                    cpf: data.cpf,
                    rg: data.rg,
                    birth_date: data.birth_date,
                    phone_primary: data.phone_primary,
                    email: data.email,
                    agreement_id: data.agreement_id,
                    number_agreement: data.number_agreement,
                    flag: data.flag,
                };

                const customerResponse = await apiRequest<ICustomer>('customer', 'POST', customerPayload);
                console.log('response: ', customerResponse);
                customer_id = customerResponse.data.id;
                setCustomerID(customer_id);
                await finalizeData(customer_id, data);
            } else {
                await finalizeData(customer_id, data);
            }
        } catch (error: any) {
            setToastData({
                status: error?.response?.status || 500,
                message: error.message || 'Erro inesperado',
            });
            setToastOpen(true);
            console.log('error: ', error);
        } finally {
            stopLoading();
        }
    };

    const finalizeData = async (id: number, data: any) => {
        try {
            // Verifica se algum campo de endereço foi preenchido
            const hasAddress =
                data.cep?.trim() ||
                data.street?.trim() ||
                data.neighborhood?.trim() ||
                data.number?.trim() ||
                data.city?.trim() ||
                data.uf?.trim() ||
                data.complement?.trim() ||
                data.reference?.trim();

            if (hasAddress && id) {
                const addressPayload = {
                    customer_id: id,
                    cep: data.cep,
                    street: data.street,
                    neighborhood: data.neighborhood,
                    number: data.number,
                    city: data.city,
                    uf: data.uf,
                    complement: data.complement,
                    reference: data.reference,
                };

                const addressResponse = await apiRequest('address', 'POST', addressPayload);

                if (addressResponse.status === 201) {
                    setToastData({
                        status: 201,
                        message: 'Cliente e endereço cadastrados com sucesso!',
                    });
                }

            } else {
                console.log('debugar: sem endereço')
                setToastData({
                    status: 201,
                    message: 'Cliente cadastrado com sucesso!',
                });
            }

            setToastOpen(true);
            refreshData();
            onClose(); // fechar modal

        } catch (error: any) {
            setToastData({
                status: error?.response?.status || 500,
                message: error.message || 'Erro inesperado',
            });
            setToastOpen(true);
            console.log('error: ', error);
        } finally {
            stopLoading();
        }
    }

    const onClose = () => {
        reset();
        setIsOpensCustomer(true);
        setIsOpenModal(); // fecha o modal
        setCustomerID(null);
    }

    if (isOpenModal) {
        return (
            <LayoutModal
                statusLoad={isLoading}
                title={textInformation.title}
                subTitle={textInformation.subTitle}
                setModalClose={onClose}
                submiteModal={handleFormSubmit(onSubmit)}
                nameSubmit={isOpensCustomer ? "Próximo" : "Finalizar"}
                nameCancel={"Cancelar"}
                nameIconMinimize={'Registrar Cliente'}
                buttonBack={!isOpensCustomer}
                setModalBack={() => setIsOpensCustomer(!isOpensCustomer)}
                setMaximizeModal={fetchData}
            >
                <S.ContentProgress>
                    <ProgressBar name="Cliente" active={isOpensCustomer} />
                    <ProgressBar name="Endereço" active={!isOpensCustomer} />
                </S.ContentProgress>
                {
                    isOpensCustomer ?
                        <FormsCustomer
                            register={register}
                            control={control}
                            errors={errors}
                            agreements={agreements}
                        />
                        :
                        <FormsAddress
                            setValue={setValue}
                            control={control}
                            register={register}
                            errors={errors}
                        />
                }
            </LayoutModal>
        )
    }
    return null;
}